import { usePaginatedApi } from "../../../swr/useApi";
import { loyaltyService } from "../../api_client";
import type { LoyaltyRedemptionDto } from "../../../api";
import type { AxiosResponse } from "axios";
import type { PaginatedResponse } from "../../pagination/data/types/pagination";

interface RedemptionsQuery {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: "asc" | "desc";
}

/**
 * Buyer's own redemption history (separate from the earning-side
 * `LoyaltyPointTransaction` list). The `getMyRedemptions` method appears
 * on the generated client after `npm run generate:api`.
 */
export function useMyLoyaltyRedemptions(query?: RedemptionsQuery) {
    return usePaginatedApi<LoyaltyRedemptionDto, RedemptionsQuery>({
        key: "my-loyalty-redemptions",
        serviceMethod: async (queryParams) => {
            const svc = loyaltyService as unknown as {
                getMyRedemptions: (
                    q?: RedemptionsQuery,
                ) => Promise<AxiosResponse<PaginatedResponse<LoyaltyRedemptionDto>>>;
            };
            return await svc.getMyRedemptions(queryParams);
        },
        query: query,
    });
}
